import { settings } from '@pixi/settings';
export { settings } from '@pixi/settings';

settings.TARGET_FPMS = 0.06;
//# sourceMappingURL=settings.mjs.map
